// WI-31 kid hooks (DRAFT, off): one line on a stage card that makes a child want to go and look.
// Renders nothing until the owner has reviewed src/domain/kidHooks.ts and flipped KID_HOOKS_LIVE.
import { kidHook } from '../domain/kidHooks'
import { placeId } from '../map/places/registry'

export function KidHookLine({ spot, season = null }: { spot: string; season?: string | null }) {
  const lines = kidHook(placeId(spot), season)
  return lines ? <small className="kid-hook">{lines[0]}</small> : null
}
